module.exports = __webpack_public_path__ + "static/media/wonkyBushes.1a5e17be.png";